import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";;
import { MatDialog } from "@angular/material/dialog";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { CatalogPaginationRequest } from "../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../shared/models/Filter/FilterRequest";
import { AlarmAPIService } from "../../shared/services/API/AlarmAPI.service";
import { ControlPanelAPIService } from "../../shared/services/API/ControlPanelAPI.service";

@Injectable({
  providedIn: "root",
})
export class ControlPanelService {
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();

  public isAlarmListVisible: boolean = false;
  public listDialogRef: any;

  rolItem: string[] = [];

  subscription_GetAlarms: Subscription;

  constructor(private controlPanelService: ControlPanelAPIService) {
  }

setLoading(resp) {
  this.isLoading$.next(resp);
}

getLoading() {
  return this.isLoading$.asObservable();
}



getResume(): any {
  return this.controlPanelService.getResume();
}


//paginacion
getFilterValues(request : FilterRequest[]) {
  return this.controlPanelService.getFilterValues(request);
}

getPage(request : CatalogPaginationRequest) {
  return this.controlPanelService.getPage(request);
}
getCount(request : CatalogPaginationRequest) {
  return this.controlPanelService.getCount(request);
}
  
}
